import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import Chat from 'modules/Chat';
import User from 'modules/User';
import Dropdown from 'components/Dropdown';

export const _UserList = ({ userRefs, username, users }) =>
  !isEmpty(userRefs) ? (
    <Dropdown
      placeholder={userRefs.length}
      asList
      name="chatUsersSelect"
      className="cs-select cs-skin-elastic chatUsersSelect"
      id="chatUsersSelect"
    >
      {userRefs.map((userRef) => {
        const user = users[userRef];
        if (!user) return null;

        return (
          <span key={userRef} className={user.isModerator ? 'dropdown__option--moderator' : ''}>
            {username === userRef
              ? `${userRef} (You)`
              : user.isModerator
              ? `${userRef} (Mod)`
              : userRef}
          </span>
        );
      })}
    </Dropdown>
  ) : null;

_UserList.propTypes = {
  channel: PropTypes.string,
  username: PropTypes.string,
  users: PropTypes.object,
  userRefs: PropTypes.arrayOf(PropTypes.string)
};

_UserList.defaultProps = {
  username: '',
  channel: '',
  users: {},
  userRefs: []
};

const mapStateToProps = (state, { channel }) => ({
  username: User.selectors.model(state).username,
  users: Chat.selectors.getUsers(state),
  userRefs: Chat.selectors.getChannelUserRefs(state, channel)
});

export default connect(mapStateToProps)(_UserList);
